/* KIRIBAN site behaviour. Every block is guarded: a missing section is skipped, never an error.
   Safe to load more than once. */
(function () {
  "use strict";
  if (window.__KB_SITE__) return;
  window.__KB_SITE__ = 1;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  function A(fn, a, b) { var X = window.KBAudio; if (X && X[fn]) X[fn](a, b); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- the window ---------- */
  (function () {
    var stage = $("#stage"), btn = $("#open"), tEl = $("#timer"), cEl = $("#cnt"),
        tix = $("#tix"), after = $("#after");
    if (!stage || !btn || !tEl || !cEl || !tix || !after) return;
    var TOTAL = 10000, GOAL = 300, used = false;
    function pad(n) { return String(n).padStart(4, "0"); }
    function mmss(ms) {
      var s = Math.max(0, Math.ceil(ms / 1000));
      return String(Math.floor(s / 60)).padStart(2, "0") + ":" + String(s % 60).padStart(2, "0");
    }
    function ticket() {
      if (reduce) return;
      var el = document.createElement("span"); el.className = "tk";
      el.style.left = (10 + Math.random() * 78) + "%"; el.style.top = "-46px";
      tix.appendChild(el);
      el.animate([
        { transform: "translateY(0) rotate(0deg)", opacity: 0 },
        { opacity: 0.95, offset: 0.12 },
        { transform: "translateY(" + (tix.clientHeight + 56) + "px) rotate(" + (Math.random() * 220 - 110) + "deg)", opacity: 0 }
      ], { duration: 1700 + Math.random() * 800, easing: "cubic-bezier(.3,.1,.5,1)" }).onfinish = function () { el.remove(); };
    }
    btn.addEventListener("click", function () {
      if (used) return;
      used = true; btn.disabled = true; btn.textContent = "Window open";
      stage.dataset.s = "open"; A("shutter", true); setTimeout(function () { A("bell"); }, 900);
      var t0 = performance.now(), lt = -1, sp = 0;
      (function f(now) {
        var el = now - t0, left = TOTAL - el;
        tEl.textContent = mmss(left);
        var p = Math.min(1, el / TOTAL);
        cEl.textContent = pad(Math.round(GOAL * (1 - Math.pow(1 - p, 2.1))));
        if (el > 1000 && now - sp > 200) { sp = now; ticket(); }
        if (left <= 3000 && stage.dataset.s === "open") stage.dataset.s = "closing";
        if (stage.dataset.s === "closing") { var s2 = Math.ceil(left / 1000); if (s2 !== lt) { lt = s2; A("tick", 1150, 0.06); } }
        if (left > 0) requestAnimationFrame(f);
        else {
          cEl.textContent = pad(GOAL); tEl.textContent = "00:00"; stage.dataset.s = "closed";
          A("shutter", false); btn.textContent = "Closed";
          setTimeout(function () { after.setAttribute("data-on", ""); }, 650);
        }
      })(performance.now());
    });
  })();

  /* ---------- hero collectible popovers ---------- */
  (function () {
    var pop = $("#pop"), stg = $("#hcstage");
    var pins = $$(".pin");
    if (!pop || !stg || !pins.length) return;
    var CAP = pins.map(function (p) {
      return [p.getAttribute("data-n") || "", p.getAttribute("data-t") || "", p.getAttribute("data-d") || ""];
    });
    var openIdx = -1;
    function closePop() {
      if (openIdx < 0) return;
      pop.removeAttribute("data-on");
      pins.forEach(function (p) { p.setAttribute("aria-expanded", "false"); });
      openIdx = -1;
    }
    function openPop(i, pin) {
      if (openIdx === i) { closePop(); return; }
      openIdx = i;
      pins.forEach(function (p, k) { p.setAttribute("aria-expanded", String(k === i)); });
      var c = CAP[i];
      pop.innerHTML = '<button class="x" type="button" aria-label="Close">&times;</button>' +
        '<p class="n"></p><h3></h3><p class="b"></p>';
      $(".n", pop).textContent = c[0];
      $("h3", pop).textContent = c[1];
      $(".b", pop).textContent = c[2];
      pop.setAttribute("data-on", "");
      var L = parseFloat(pin.style.left), T = parseFloat(pin.style.top),
          w = pop.offsetWidth, sw = stg.clientWidth, sh = stg.clientHeight,
          px = L / 100 * sw, py = T / 100 * sh, x = px + 22, y = py - 10;
      if (x + w > sw - 4) x = px - w - 22;
      if (x < 4) x = 4;
      var h = pop.offsetHeight;
      if (y + h > sh - 4) y = sh - h - 4;
      if (y < 4) y = 4;
      pop.style.left = x + "px"; pop.style.top = y + "px";
      A("tick", 980, 0.04);
    }
    pins.forEach(function (p, i) { p.addEventListener("click", function (e) { e.stopPropagation(); openPop(i, p); }); });
    pop.addEventListener("click", function (e) { if (e.target.classList.contains("x")) closePop(); });
    document.addEventListener("click", function (e) { if (!stg.contains(e.target)) closePop(); });
  })();

  /* ---------- collection rail ---------- */
  (function () {
    var crail = $("#crail");
    var cb = $$("[data-r]");
    if (!crail || cb.length < 2) return;
    cb.forEach(function (b) {
      b.addEventListener("click", function () {
        var c = crail.querySelector(".ci");
        var step = (c ? c.offsetWidth + 16 : 200) * 2;
        crail.scrollBy({ left: +b.dataset.r * step, behavior: reduce ? "auto" : "smooth" });
      });
    });
    function cstate() {
      var max = crail.scrollWidth - crail.clientWidth - 2;
      cb[0].disabled = crail.scrollLeft <= 2;
      cb[1].disabled = crail.scrollLeft >= max;
    }
    crail.addEventListener("scroll", cstate, { passive: true });
    addEventListener("resize", cstate);
    cstate();
    $$(".ci", crail).forEach(function (n, i) { n.style.transitionDelay = (i * 0.06) + "s"; });
  })();

  /* ---------- benefits accordion ---------- */
  (function () {
    var bts = $$(".bt");
    if (!bts.length) return;
    bts.forEach(function (b) {
      b.addEventListener("click", function () {
        var isOpen = b.getAttribute("aria-expanded") === "true";
        bts.forEach(function (o) { o.setAttribute("aria-expanded", "false"); });
        b.setAttribute("aria-expanded", String(!isOpen));
        A("tick", 860, 0.035);
      });
    });
  })();

  /* ---------- countdown (flip clock) ---------- */
  (function () {
    var wrap = $("[data-kb-clock]");
    var cds = { d: $('[data-cd="d"]'), h: $('[data-cd="h"]'), m: $('[data-cd="m"]'), s: $('[data-cd="s"]') };
    if (!wrap || !cds.d || !cds.h || !cds.m || !cds.s) return;
    var iso = wrap.getAttribute("data-kb-clock") || "2027-01-15T12:00:00+09:00";
    var GO = new Date(iso).getTime();
    if (isNaN(GO)) return;
    var prev = {};
    function setU(k, v) {
      if (prev[k] === v) return;
      prev[k] = v;
      var el = cds[k]; el.textContent = v;
      var card = el.parentNode;
      if (reduce) return;
      card.classList.remove("flip"); void card.offsetWidth; card.classList.add("flip");
    }
    function cd() {
      var t = Math.max(0, GO - Date.now()), s = Math.floor(t / 1000);
      setU("d", String(Math.floor(s / 86400)).padStart(2, "0"));
      setU("h", String(Math.floor(s / 3600) % 24).padStart(2, "0"));
      setU("m", String(Math.floor(s / 60) % 60).padStart(2, "0"));
      setU("s", String(s % 60).padStart(2, "0"));
    }
    cd(); setInterval(cd, 1000);
  })();

  /* ---------- scroll reveals ---------- */
  (function () {
    var els = $$(".up");
    if (!els.length) return;
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.setAttribute("data-in", ""); io.unobserve(e.target); } });
      }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" });
      els.forEach(function (n) { io.observe(n); });
    } else {
      els.forEach(function (n) { n.setAttribute("data-in", ""); });
    }
  })();

  /* ---------- subscribe form + thank-you ---------- */
  (function () {
    var thanks = $("#thanks"), form = $("#form2");
    if (!thanks || !form) return;
    var ct = $("#ct");
    function show() { thanks.setAttribute("data-on", ""); document.body.style.overflow = "hidden"; A("bell"); }
    function hide() { thanks.removeAttribute("data-on"); document.body.style.overflow = ""; }
    function note(t) {
      var p = form.querySelector(".fmsg.js");
      if (!p) {
        p = document.createElement("p");
        p.className = "fmsg ferr js";
        p.setAttribute("role", "alert");
        form.appendChild(p);
      }
      p.textContent = t || "";
    }
    form.addEventListener("submit", function (e) {
      var inp = form.querySelector('input[type="email"]');
      note("");
      if (!inp || !inp.value || inp.value.indexOf("@") < 1) { e.preventDefault(); note("Please enter a valid email address."); if (inp) inp.focus(); return; }
      if (form.getAttribute("data-kb-demo") === "1") { e.preventDefault(); show(); }
    });
    if (document.getElementById("kb-posted")) show();
    if (ct) ct.addEventListener("click", hide);
    thanks.addEventListener("click", function (e) { if (e.target === thanks) hide(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hide(); });
  })();
})();
